// Generated types for AttributeDefinition
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { AttributeDataType } from '../enums';

import { SysMLElementReadAPI, SysMLElementWriteAPI } from './sysmlelement';
import { SysMLElementReadAPISchemaObject, SysMLElementWriteAPISchemaObject } from './sysmlelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface AttributeDefinitionReadAPI extends SysMLElementReadAPI {
  value_type?: AttributeDataType;
  value?: string | null;
  unit?: string | null;
  multiplicity_lower?: number | null;
  multiplicity_upper?: number | null;
}

export interface AttributeDefinitionWriteAPI extends SysMLElementWriteAPI {
  value_type?: AttributeDataType;
  value?: string | null;
  unit?: string | null;
  multiplicity_lower?: number | null;
  multiplicity_upper?: number | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const AttributeDefinitionReadAPISchemaObject = SysMLElementReadAPISchemaObject.extend({
  value_type: z.nativeEnum(AttributeDataType).optional(),
  value: z.string().nullable().optional(),
  unit: z.string().nullable().optional(),
  multiplicity_lower: z.number().nullable().optional(),
  multiplicity_upper: z.number().nullable().optional(),
}).passthrough();
export const AttributeDefinitionReadAPISchema: z.ZodType<AttributeDefinitionReadAPI> = AttributeDefinitionReadAPISchemaObject;

export const AttributeDefinitionWriteAPISchemaObject = SysMLElementWriteAPISchemaObject.extend({
  value_type: z.nativeEnum(AttributeDataType).optional(),
  value: z.string().nullable().optional(),
  unit: z.string().nullable().optional(),
  multiplicity_lower: z.number().nullable().optional(),
  multiplicity_upper: z.number().nullable().optional(),
}).passthrough();
export const AttributeDefinitionWriteAPISchema: z.ZodType<AttributeDefinitionWriteAPI> = AttributeDefinitionWriteAPISchemaObject;
